import { useTranslation } from "react-i18next";
import KiloNewton from "../../../../../components/Math/Units/Metric/KiloNewton";
import { NumberFormatText } from "../../../../../components/NumberFormatText";
import { RowBody } from "../../../../../components/RowValue/RowBody";

function Dehnsteifigkeit({ dehnsteifigkeit }) {
  const { t } = useTranslation("translation");

  return (
    <RowBody
      titleValue={<p>{t("inner.buckling.ofner.parameterTragglied.axialStiffness")}</p>}
      indicesValue={
        <span>
          EA<sub>s</sub>
        </span>
      }
      inputValue={
        <span className="input">
          <NumberFormatText value={dehnsteifigkeit} decimalScale={0} />
        </span>
      }
      unitValue={<KiloNewton />}
    />
  );
}

export default Dehnsteifigkeit;
